<template>
  <div class="date-container" style="z-index:99999999">
    <div class="titleBg" v-if="titleShow">
      <div class="left">
        <span class="title">{{titleText}}</span>
        <div class="top_text">
          <slot name="topText"></slot>
        </div>
      </div>
      <span class="dateBg" @click="timeClick()" v-if="pickerShow">
        {{showDateInfo}}
        <van-icon name="arrow-down" />
      </span>
    </div>
    <div class="date-wrap" style="z-index:99999999">
      <van-popup v-model="show" closeable round position="bottom" style="height:450px;z-index:99999999">
        <div class="popupBg" style="z-index:99999999">
          <p class="title">选择时间</p>
          <van-tabs type="card" color="#999" v-model="activeTime" @click="activeTimeClick()">
            <van-tab title="按日"></van-tab>
            <van-tab title="按月"></van-tab>
            <!-- <van-tab title="按季"></van-tab> -->
          </van-tabs>
          <div class="timeBg" v-show="monthFlag">
            <div @click="clickTime1">
              <el-input :class="{actvieColor:actcor1}" placeholder="请选择开始时间" readonly v-model="dateTimeStart">
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-input>
            </div>
            <span>至</span>
            <div @click="clickTime2">
              <el-input :class="{actvieColor:actcor2}" placeholder="请选择结束时间" readonly v-model="dateTimeEnd">
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-input>
            </div>
          </div>
          <div class="timeBg" v-show="quarterFlag">
            <div @click="clickTime1">
              <el-input :class="{actvieColor:actcor1}" placeholder="请选择季度" readonly v-model="dateTimeStart">
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-input>
            </div>
            <span>至</span>
            <div @click="clickTime2">
              <el-input :class="{actvieColor:actcor2}" placeholder="请选择季度" readonly v-model="dateTimeEnd">
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-input>
            </div>
          </div>
          <p class="tit" v-show="monthFlag">{{tit}}</p>
          <div class="wrap-daymonth" v-show="monthFlag">
            <van-datetime-picker v-model="dateTimePicker1" :type="dateType" v-show="showTime" :visible-item-count="3" :show-toolbar="false" title="选择年月日" @change="timeChange"  :max-date="maxDate1" />
            <van-datetime-picker v-model="dateTimePicker2" :type="dateType" v-show="!showTime" :visible-item-count="3" :show-toolbar="false" @change="timeChange" title="选择年月日"  :max-date="maxDate2" />
          </div>
          <div class="wrap-square" v-show="quarterFlag" style="padding-bottom:100px">
            <van-picker ref="vanPicker" show-toolbar title="" :columns="columns" :default-index="2" @confirm="timePiecker" disabled='true' @change='timeChage' @cancel="cancel" />
          </div>

          <div class="btnBg" v-show="monthFlag">
            <button class="no" @click="cancel">取消</button>
            <button class="sure" @click="sure">确定</button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { decryptBy } from '@/assets/js/encryption';
  export default {
    name: 'date',
    components: {},
    props: {
      titleText: {
        type: String,
        default: '请输入标题'
      },
      showDateInfo: {
        type: String,
        default: '请选择时间'
      },
      titleShow: {
        type: Boolean,
        default: true
      },
      pickerShow: {
        type: Boolean,
        default: true
      },
      originTime: {
        type: String,
        default: ''
      },
      finallyTime: {
        type: String,
        default: ''
      },
      formatOriginTime: {
        type: String,
        default: ''
      },
      formatFinallyTime: {
        type: String,
        default: ''
      },
      showMark: {
        type: Boolean,
        default: false
      },
      content: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        changeFlag: false,//季度是否change取值
        tempStoreStartTime: '',//暂时季度下拉取值
        tempStoreEndTime: '',//暂时季度下拉取值
        columns: [
          {
            values: [],
            defaultIndex: 0,
          },
          {
            values: [],
            defaultIndex: 0,
          },
        ],
        quarterFlag: false,//当前切换是否是季，季度为true
        monthFlag: true,//当前切换是否是日月
        show: false,//底层显示时间弹框
        activeTime: 0, //按日、按月、按年
        dateTimePicker1: new Date(),  //年月日时间控件开始
        dateTimePicker2: new Date(),  //年月日时间控件结束
        dateTimeStart: '',//开始时间
        dateTimeEnd: '',//结束时间
        showTime: true,  //时间控件切换
        dateType: "date", //时间控件年月日
        tit: "请选择开始时间",
        timeDate: '',//时间组件按日默认展示当天
        timeMonth: '',//时间组件按日默认展示当月
        timeYear: '',//时间组件按日默认展示当年
        timeQuarter: '',//时间组件按日默认展示当季度
        minDate1: new Date(1900, 0, 1), //最小时间
        maxDate1: new Date(), //最大时间
        minDate2: new Date(1900, 0, 1), //最小时间
        maxDate2: new Date(), //最大时间
        actcor1: true,//时间框是否添选中颜色
        actcor2: false,//时间框是否添选中颜色
        // formatOriginTimeCopy:this.formatOriginTime
      };
    },
    watch: {},
    computed: {},
    methods: {
      // 点击季度的确定事件
      timePiecker() {
        this.sure()
      },
      timeChage(val, eventValue) {
        // 代表已经通过划拉选值了
        this.changeFlag = true
        let formatTime1, formatTime2;
        let yearTime = eventValue[0]
        let querTime = eventValue[1]
        switch (querTime) {
          case '第一季度':
            formatTime1 = '01-01'
            formatTime2 = '03-31'
            break;
          case '第二季度':
            formatTime1 = '04-01'
            formatTime2 = '06-30'
            break;
          case '第三季度':
            formatTime1 = '07-01'
            formatTime2 = '09-30'
            break;
          case '第四季度':
            formatTime1 = '10-01'
            formatTime2 = '12-31'
            break;
        }
        let dealTimeStart = (yearTime + '-' + formatTime1)
        let dealTimeEnd = (yearTime + '-' + formatTime2)
        this.dateTimeStart = dealTimeStart
        this.dateTimeEnd = dealTimeEnd
        this.tempStoreStartTime = this.dateTimeStart
        this.tempStoreEndTime = this.dateTimeEnd
      },
      //年月日切换
      activeTimeClick() {
        // 默认展示当天年月日
        this.timeCurrent()
        // 年月季切换，获取类型[日：day 月：month ]
        // 时间类型为共用
        if (this.activeTime === 0) {
          // this.dateType = 'date';
          this.$emit('dateType', 'day')
          // 对应的季度页面不显示
          this.quarterFlag = false
          // 显示月 年 页面
          this.monthFlag = true
          let dataTime1 = [1, 3, 5, 7, 8, 10, 12]
          let dataTime2 = [4, 6, 8, 10, 11]
          let dataTime3 = [2]
          let one = new Date(this.dateTimeEnd).getMonth() + 1
          let valueLine = ''
          if (dataTime1.indexOf(one) != -1) {
            valueLine = '31'
          } else if (dataTime2.indexOf(one) != -1) {
            valueLine = '30'
          } else if (dataTime3.indexOf(one) != -1) {
            valueLine = '28'
          } else {
            valueLine = '01'
          }
          if (this.dateTimeStart.length < 10) {
            this.dateTimeStart = this.dateTimeStart + '-01'
            this.dateTimeEnd = this.dateTimeEnd + '-' + valueLine
          }
          // 如果传入的结束时间大于当天的时间，结束时间就显示当天的时间
          let TransMonth = new Date(this.dateTimeEnd).getMonth() + 1
          let TodayMonth = new Date().getMonth() + 1
          if (TodayMonth < 10) {
            TodayMonth = '0' + TodayMonth
          }
          if (TransMonth >= TodayMonth) {
            let currentMonth = new Date().getMonth() + 1
            if (currentMonth < 10) {
              currentMonth = '0' + currentMonth
            }
            // this.dateTimeEnd = new Date(this.dateTimeEnd).getFullYear() + '-' + TodayMonth + '-*' + valueLine
            let dayTemp = new Date().getDate()
            if (dayTemp < 10) {
              dayTemp = '0' + dayTemp
            }
            this.dateTimeEnd = new Date().getFullYear() + '-' + currentMonth + '-' + dayTemp
          }

        } else if (this.activeTime === 1) {
          this.quarterFlag = false
          this.monthFlag = true
          // this.dateType = 'month';
          this.$emit('dateType', 'month')
          // 如果传入的结束时间大于当天的时间，结束时间就显示当天的时间
          let TransMonth = new Date(this.dateTimeEnd).getMonth() + 1
          let TodayMonth = new Date().getMonth() + 1
          if (TodayMonth < 10) {
            TodayMonth = '0' + TodayMonth
          }
          if (TransMonth >= TodayMonth) {
            let currentMonth = new Date().getMonth() + 1
            if (currentMonth < 10) {
              currentMonth = '0' + currentMonth
            }
            // this.dateTimeEnd = new Date(this.dateTimeEnd).getFullYear() + '-' + TodayMonth + '-*' + valueLine
            this.dateTimeEnd = new Date().getFullYear() + '-' + currentMonth
          }
        } else if (this.activeTime === 2) {
          if (this.changeFlag) {
            this.dateTimeStart = this.tempStoreStartTime
            this.dateTimeEnd = this.tempStoreEndTime
          }
          this.monthFlag = false
          // 显示季度
          this.quarterFlag = true
          this.$emit('dateType', 'day')
          if (this.dateTimeStart.length < 10) {
            this.dateTimeEnd = this.dateTimeEnd + '-01'
          }
        }

        // 切换年月季默认开始时间
        this.clickTime1()
        // 切换年月日，时间选择器默认到当日状态cyc
        this.dealChooseTime()
      },
      //
      clickTime1() {
        this.tit = "请选择开始时间";
        this.showTime = true;
        this.actcor1 = true
        this.actcor2 = false
      },
      clickTime2() {
        this.tit = "请选择结束时间";
        this.showTime = false;
        this.actcor1 = false
        this.actcor2 = true
        // this.dealChooseTime()
      },
      //时间组件确定按钮
      sure() {
        // 点击后保存当前选择年月日
        if (this.activeTime === 0) {
          sessionStorage.setItem('timeType', 0)
        } else if (this.activeTime === 1) {
          sessionStorage.setItem('timeType', 1)
        } else if (this.activeTime === 2) {
          sessionStorage.setItem('timeType', 2)
        } else {
          sessionStorage.setItem('timeType', 0)
        }
        if (!this.dateTimeStart && this.monthFlag) {
          Toast('请选择开始时间!');
          return false;
        }
        if (!this.dateTimeEnd && this.monthFlag) {
          Toast('请选择结束时间!');
          return false;
        }
        if (this.dateTimeStart.split('-').join('') - this.dateTimeEnd.split('-').join('') > 0) {
          this.compareNum(this.dateTimeStart.split('-').join(''), this.dateTimeEnd.split('-').join(''))
          return
        }
        if (!this.dateTimeStart && this.quarterFlag) {
          Toast('请选择季度!');
          return false;
        }
        if (!this.dateTimeEnd && this.quarterFlag) {
          Toast('请选择季度!');
          return false;
        }
        // 每次点击确定后，恢复默认的按日选择时间
        this.activeTime = 0
        // 点击确定后，传递开始/结束时间
        // 食材来源统计的开始结束时间
        this.$emit('startTimeFn', this.dateTimeStart)
        this.$emit('endTimeFn', this.dateTimeEnd)
        this.show = false;
      },
      cancel() {
        this.show = false,
          this.activeTime = 0
      },
      //时间控件改变事件
      timeChange(data) {
        if (this.tit === "请选择开始时间") {
          if (this.activeTime === 0) {
            this.dateTimeStart = data.getColumnValue(0) + '-' + data.getColumnValue(1) + '-' + data.getColumnValue(2);
          } else if (this.activeTime === 1) {
            this.dateTimeStart = data.getColumnValue(0) + '-' + data.getColumnValue(1);
          } else if (this.activeTime === 2) {
            this.dateTimeStart = data.getColumnValue(0) + '-' + data.getColumnValue(1);
          }
        } else {
          if (this.activeTime === 0) {
            this.dateTimeEnd = data.getColumnValue(0) + '-' + data.getColumnValue(1) + '-' + data.getColumnValue(2);
          } else if (this.activeTime === 1) {
            this.dateTimeEnd = data.getColumnValue(0) + '-' + data.getColumnValue(1);
          } else if (this.activeTime === 2) {
            this.dateTimeEnd = data.getColumnValue(0) + '-' + data.getColumnValue(1);
          }
        }
      },
      // 比较两个数值的大小
      compareNum(val1, val2) {
        if (val2 - val1 < 0) {
          // Toast("结束时间不能小于开始时间")
          // this.dateTimeEnd = ''
          this.dateTimePicker2 = new Date()
          this.dateTimeEnd = this.dealTime(new Date())
          return false
        }
      },
      // 处理结束时间小于开始时间时间选择器回显问题
      dealChooseTime() {
        // 此处处理时间为后台传递过来的时间回显到控件里面
        const Time = new Date()
        if (this.activeTime === 0) {
          this.dateType = 'date';
          let tempV = ''
          tempV = this.formatOriginTime
          // 当回传的时间格式为2012-01
          if (tempV.length == 7) {
            tempV = this.formatOriginTime + '/' + '01'
          }
          this.dateTimePicker1 = new Date(tempV)//兼容IOS 格式需要为 new date(2021/03/04)
          // 这里需要处理一下当时间为按月传递后的时间，切换为按日后，回显正确的时间选择轴
          let tempTimeArr = []
          let tempValue = this.formatFinallyTime //此时接收的为（2012，06），需要更换为2012/06/30
          if (tempValue.length == 10) { //如果当前结束时间是2021/03/21,那么就不能按照处理传如的为2012、05的时间处理格式
            this.dateTimePicker2 = new Date(this.formatFinallyTime)
            return
          }
          let theValArr = tempValue.split('/')
          let arr1 = ['01', '03', '05', '07', '08', '10', '12']
          let arr2 = ['04', '06', '09', '11']
          let arr3 = ['02']
          let formatVal = ''
          if (arr1.indexOf(theValArr[1]) != -1) {//31天
            formatVal = theValArr[0] + '/' + theValArr[1] + '/' + '31'
          } else if (arr2.indexOf(theValArr[1]) != -1) {
            formatVal = theValArr[0] + '/' + theValArr[1] + '/' + '30'
          } else if (arr3.indexOf(theValArr[1]) != -1) {
            formatVal = theValArr[0] + '/' + theValArr[1] + '/' + '28'
          } else {
            formatVal = new Date()
          }
          this.dateTimePicker2 = new Date(formatVal)
        } else if (this.activeTime === 1) {
          this.dateType = 'year-month';
          this.dateTimePicker1 = new Date(this.formatOriginTime)//格式为（2021，5）
          this.dateTimePicker2 = new Date(this.formatFinallyTime)
        } else if (this.activeTime === 2) {
          this.dateType = 'year-month';
          this.dateTimePicker1 = Time
          this.dateTimePicker2 = Time
        }
      },
      // 处理结束时间小于开始时间输入框中时间回显问题
      dealTime(val) {
        if (this.activeTime === 0) {
          return this.formatDate(val)
        } else if (this.activeTime === 1) {
          return this.formatMonth(val)
        } else if (this.activeTime === 2) {
          //  return this.formatQuarter(val)
        }
      },
      //格式化日期-year-month-day
      formatDate(val) {
        if (!val) return;
        let y = val.getFullYear();
        let m = val.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        let d = val.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
      },
      //格式化日期-year-month
      formatMonth(val) {
        if (!val) return;
        let y = val.getFullYear();
        let m = val.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        return y + '-' + m
      },
      formatYear(val) {
        if (!val) return;
        let y = val.getFullYear();
        return y
      },
      // formatQuarter(val) {
      //   if(!val) return;
      //   let y = val.getFullYear();
      //   let m = val.getMonth() + 1;
      //   let currQuarter = Math.floor( ( m % 3 == 0 ? ( m / 3 ) : ( m / 3 + 1 ) ) );
      //   let currQuarterNumber;
      //   if(currQuarter === 1) {
      //     currQuarterNumber='第一季度'
      //   } else if (currQuarter === 2) {
      //     currQuarterNumber='第二季度'
      //   } else if (currQuarter === 3) {
      //     currQuarterNumber='第三季度'
      //   } else if (currQuarter === 4) {
      //     currQuarterNumber='第四季度'
      //   }
      //   return y + '-' + currQuarterNumber ;
      // },
      //显示时间控件
      timeClick() {
        // 重置为按日显示
        this.quarterFlag = false
        this.monthFlag = true
        this.timeCurrent()
        this.clickTime1()
        // 回显时间选择器的当前时间
        this.dealChooseTime()
        // this.activeTime = 0
        // 时间类型日 月 季 按照用于点击过的保存显示
        let typeDeatil = sessionStorage.getItem('timeType')
        if (typeDeatil == 0) {
          this.activeTime = 0 //日
          this.dateType = 'date';
        } else if (typeDeatil == 1) {
          this.activeTime = 1 //月
          this.dateType = 'year-month';
        } else if (typeDeatil == 2) {
          this.activeTime = 2 //季
          this.dateType = 'year-month';
          this.monthFlag = false
          // 显示季度
          this.quarterFlag = true
        } else {
          this.activeTime = 0
        }
        this.show = true;
        // 重置时间类型为日day
        // this.$emit('dateType','day')

      },
      // 弹出弹框&切换日期年月任tab初始化为当前时间
      timeCurrent() {
        if (this.activeTime === 0) {
          this.dateTimeStart = this.originTime
          this.dateTimeEnd = this.finallyTime
        } else if (this.activeTime === 1) {
          this.dateTimeStart = this.originTime.slice(0, 7)
          this.dateTimeEnd = this.finallyTime.slice(0, 7)
        } else if (this.activeTime === 2) {
          this.dateTimeStart = '2021-01-01'
          this.dateTimeEnd = '2021-03-31'
        } else {
          this.dateTimeStart = this.timeDate
          this.dateTimeEnd = this.timeDate
        }
      }
    },
    beforeCreate() { },
    created() {
      //to do: 时间最小的时间为创建账号的时候，暂时注释掉
      if (localStorage.getItem("userInfo")) {
        let info = localStorage.getItem("userInfo");
        let user = JSON.parse(decryptBy(info));
        this.minDate1 = new Date(user.createTime)
        this.minDate2 = new Date(user.createTime)
      }
      this.timeDate = this.formatDate(new Date())
      this.timeMonth = this.formatMonth(new Date())
      this.timeYear = this.formatYear(new Date())
      // this.timeQuarter = this.formatQuarter(new Date())
      // 设置年以及对应的defaultIndex
      let yearArr = []
      let DateNow = new Date().getFullYear()
      for (let i = DateNow - 7; i <= DateNow; i++) {
        yearArr.push(i)
      }
      let yearArrLength = yearArr.length - 1
      this.columns[0].values = yearArr
      this.columns[0].defaultIndex = yearArrLength
      // 设置季度的值
      let squareArr = []
      let monthData = new Date().getMonth() + 1
      let arr1 = [1, 2, 3]
      let arr2 = [4, 5, 6]
      let arr3 = [7, 8, 9]
      let arr4 = [10, 11, 12]
      if (arr1.indexOf(monthData) != -1) {
        this.columns[1].values = ['第一季度']
      } else if (arr2.indexOf(monthData) != -1) {
        this.columns[1].values = ['第一季度', '第二季度']
      } else if (arr3.indexOf(monthData) != -1) {
        this.columns[1].values = ['第一季度', '第二季度', '第三季度']
      } else if (arr4.indexOf(monthData) != -1) {
        this.columns[1].values = ['第一季度', '第二季度', '第三季度', '第四季度']
      }
    },
    beforeMount() { },
    mounted() { },
    activated() { },
    deactivated() { },
    beforeDestroy() {
      sessionStorage.removeItem('timeType')
    },
    destroyed() { }
  };
</script>

<style lang="scss" scoped>
  ::v-deepvan-overlay {
    z-index: 99999999;
  }
  ::v-deep.van-popup {
    z-index: 11111111 !important;
  }
  ::v-deep.van-tabs__nav--card .van-tab.van-tab--active {
    color: #ff8400 !important;
    background-color: #fff !important;
  }
  ::v-deep.van-tabs__nav--card,
  ::v-deep.van-tabs--card .van-tabs__wrap {
    height: 40px !important;
    font-size: 16px;
  }
  ::v-deep.van-tabs__wrap--scrollable .van-tab {
    padding: 0;
    justify-content: flex-start;
  }
  ::v-deep.van-tabs__line {
    margin-left: -5px;
  }
  ::v-deep.van-tabs__wrap--scrollable .van-tabs__nav--complete {
    padding: 0 0 15px 0;
  }
  ::v-deep.van-tabs__nav--card {
    border-radius: 4px;
    border: 1px solid #d5d4e1;
    margin: 0;
  }
  ::v-deep.van-tab--active {
    color: #333;
    font-size: 16px;
    font-weight: 600;
  }
  ::v-deep.el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #f8f7fe;
    color: #ff8400;
  }
  .date-container {
    .actvieColor {
      border-radius: 4px 6px 6px 6px;
      border: 1px solid rgb(255, 191, 131); //xxxxxx
    }
    .titleBg {
      width: 100%;
      height: 22px;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      color: #333;

      .left {
        display: flex;
        justify-content: center;
        img {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .title {
        // min-width: 96px;
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        font-weight: 600;
      }
      .dateBg {
        display: flex;
        align-items: center;
        font-size: 14px;
        height: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      i {
        margin-left: 3px;
      }
    }
    .date-wrap {
      .popupBg {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        .wrap-square {
          height: 400px;
          overflow: hidden;
        }
        .title {
          font-size: 15px;
          font-weight: 400;
          color: #000000;
          line-height: 60px;
          text-align: center;
        }
        .tit {
          font-size: 14px;
          font-weight: 400;
          color: #666;
          line-height: 14px;
          text-align: center;
        }
        ::v-deep.van-tab--active {
          background-color: #ff8400 !important;
          color: #fff !important;
        }
        ::v-deep.van-tabs__wrap,
        ::v-deep.tablist,
        ::v-deep.van-tab,
        ::v-deep.van-tabs__nav {
          width: 214px !important;
          height: 32px !important;
          line-height: 32px !important;
          box-sizing: border-box;
          margin: 0 auto;
        }
        .timeBg {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 25px 0;
          span {
            font-size: 14px;
            margin: 0 10px;
          }
          ::v-deep.el-input {
            width: 140px !important;
            height: 30px !important;
            line-height: 30px !important;
          }
          ::v-deep.el-input__inner {
            width: 140px !important;
            height: 30px !important;
            line-height: 30px !important;
            background: rgba(254, 182, 115, 0.06) !important;
            border-radius: 4px 6px 6px 6px !important;
            border: 1px solid rgba(255, 197, 131, 0.21); //xxxxxx
          }
          ::v-deep.el-input__icon {
            line-height: 30px !important;
            color: #ff8400 !important;
          }
        }
        ::v-deep.van-picker-column__item--selected {
          font-size: 20px !important;
          background: #faf9fd !important;
        }
        .btnBg {
          width: 100%;
          padding: 20px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          .no {
            width: 129px;
            height: 38px;
            border-radius: 19px;
            border: 2px solid rgb(252, 186, 111);
            background: #fff;
            color: rgb(252, 186, 111);
            box-sizing: border-box;
            margin-right: 20px;
          }
          .sure {
            width: 129px;
            height: 38px;
            background: linear-gradient(180deg, #ffdeb2 0%, #ff8400 100%);
            border-radius: 19px;
            border: 0;
            color: #fff;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  ::v-deep button.van-picker__confirm {
    width: 129px;
    height: 38px;
    background: linear-gradient(180deg, #ffdeb2 0%, #ff8400 100%);
    border-radius: 19px;
    border: 0;
    color: #fff;
    box-sizing: border-box;
    margin-right: 50px;
  }
  ::v-deep .van-picker__cancel {
    width: 129px;
    height: 38px;
    border-radius: 19px;
    border: 2px solid rgb(252, 196, 111);
    background: #fff;
    color: rgb(252, 191, 111);
    box-sizing: border-box;
    margin-left: 50px;
    margin-right: 20px;
  }
  ::v-deep .van-picker__toolbar {
    z-index: 90;
    position: absolute;
    bottom: 10px;
  }
  ::v-deep .van-popup.van-popup--center {
    // text-indent: 2em;
    padding: 50px 20px;
    border-radius: 10px;
    font-size: 14px;
    width: 300px;
    height: auto;
  }
</style>
